import { HttpErrorResponse } from '@angular/common/http';

export interface MiddlewareError<T = any, S = any> extends HttpErrorResponse {
  error: MiddlewareBodyError<T, S>;
}

interface MiddlewareBodyError<T = any, S = any> {
  errorKey: T;
  errorDescription: string;
  errorType: string;
  extraData?: S;
}

export const getErrorKey = <T>(error: MiddlewareError<T>) =>
  error && error.error && error.error.errorKey;
export const getExtraData = <T, S>(error: MiddlewareError<T, S>) =>
  error && error.error && error.error.extraData;
